const ROLLING_MATURITY = "0b11849b-9bed-11e9-8b5f-00ff12c3b408";
const CONSTANT_MATURITY = "1253d73b-9bed-11e9-8b5f-00ff12c3b408";

export default {
  ROLLING_MATURITY,
  CONSTANT_MATURITY
};
